import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  PeriodPicker: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  timeBox: {
    width: "120px",
    height: "40px",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#4d1277",
    textAlign: "center",
  },
  headText: {
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
    color: "#272525",
  },
}));

export default useStyles;
